// What an action would set off, for its button: the cards that react to it (from their previews, e.g. "Maria Theresa:
// +1 science, +1 culture" on Increase Population), a civil action for some actions only that it would use (Gutenberg's
// "+2 culture"), and the Nobel Prize it would earn at the end of the turn. Worked out without changing anything.
const { MoveTypes } = require('./MoveTypes');
const { PreviewTriggers, TriggerEvents, TurnFlags } = require('../Effects/Effects');

// The event an action sets off, and its context, by move type (from the move, before it is made)
const EventOf = {
    [MoveTypes.IncreasePopulation]: () => [TriggerEvents.PopulationIncrease, { free: false }],
    [MoveTypes.OceanLinerPopulation]: () => [TriggerEvents.PopulationIncrease, { free: true }],
    [MoveTypes.BarbarossaRecruit]: () => [TriggerEvents.PopulationIncrease, { free: false }],
    [MoveTypes.DiscoverTechnology]: (player, move) => [TriggerEvents.Develop, { tech: player.civilHand.find(c => c?.id === move.cardId)?.Technology }],
    [MoveTypes.ChangeGovernment]: (player, move) => [TriggerEvents.Develop, { tech: player.civilHand.find(c => c?.id === move.cardId)?.Technology }],
    [MoveTypes.PrepareEvent]: (player, move) => [TriggerEvents.PrepareEvent, { card: player.militaryHand.find(c => c?.id === move.cardId) }],
};
// What a civil action for some actions only would pay for, by move type
const RestrictedContext = {
    [MoveTypes.DiscoverTechnology]: (player, move) => ({ tech: player.civilHand.find(c => c?.id === move.cardId)?.Technology }),
    [MoveTypes.Build]: (player, move) => ({ tech: player.GetTechnology(move.techName) }),
    [MoveTypes.Upgrade]: (player, move) => ({ tech: player.GetTechnology(move.toTech) }),
};

// ["Maria Theresa: +1 science, +1 culture", ...] for a move (an action card's own action counts as that action)
const TriggerGains = (gameState, move) => {
    const player = gameState.playerStates[move.player];
    const action = move.type === MoveTypes.PlayActionCard && move.inner ? { ...move.inner, player: move.player } : move;
    if (!player)
    {
        return [];
    }
    const gains = [];
    const event = EventOf[action.type]?.(player, action);
    if (event)
    {
        gains.push(...PreviewTriggers(player, ...event));
    }
    const context = RestrictedContext[action.type]?.(player, action);
    const restricted = context && player.RestrictedFor(context);
    if (restricted?.gain)
    {
        gains.push(`${restricted.Source?.name}: ${restricted.gain}`);
    }
    // Building wonder stages: what the wonder does for them (Stonehenge)
    if (action.type === MoveTypes.BuildWonderStage && player.wonderInProgress)
    {
        const wonder = player.wonderInProgress;
        const definition = require('../Constants/CardVersions').WonderDefinition(wonder.card);
        const text = definition?.previewStages?.(player, wonder.card, wonder.card.stageCosts.slice(wonder.stagesBuilt, wonder.stagesBuilt + (action.stages ?? 1)));
        if (text)
        {
            gains.push(`${wonder.card.name}: ${text}`);
        }
    }
    // Playing a war or aggression during the Olympic Games costs 8 culture
    if (gameState.olympics && (action.type === MoveTypes.PlayAggression || action.type === MoveTypes.DeclareWar))
    {
        gains.push("Olympic Games: -8 culture");
    }
    // The second technology developed this turn earns the Nobel Prize
    if (event?.[0] === TriggerEvents.Develop && gameState.nobelPrize
        && player.turnFlags.filter(flag => flag === TurnFlags.Developed).length === 1)
    {
        gains.push("Nobel Prize: +4 culture at the end of the turn");
    }
    return gains;
};

module.exports = { TriggerGains, RestrictedContext };
